import { memo, SVGProps } from 'react';

function GlassesIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      {...props}
      data-testid="GlassesIcon"
    >
      <path
        d="M6.5 19C8.70914 19 10.5 17.2091 10.5 15C10.5 12.7909 8.70914 11 6.5 11C4.29086 11 2.5 12.7909 2.5 15C2.5 17.2091 4.29086 19 6.5 19Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 19C20.7091 19 22.5 17.2091 22.5 15C22.5 12.7909 20.7091 11 18.5 11C16.2909 11 14.5 12.7909 14.5 15C14.5 17.2091 16.2909 19 18.5 19Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 15C14.5 14.4696 14.2893 13.9609 13.9142 13.5858C13.5391 13.2107 13.0304 13 12.5 13C11.9696 13 11.4609 13.2107 11.0858 13.5858C10.7107 13.9609 10.5 14.4696 10.5 15"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3 13L5.5 7C6.2 5.7 6.9 5 8.5 5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M22 13L19.5 7C18.8 5.7 18 5 16.5 5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
export default memo(GlassesIcon);
